module.exports = __webpack_public_path__ + "static/media/bolon-design-2.79e1ad0c.jpg";